import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {ChevronRight, Heart, LogIn, MapPin, ShieldCheck, Sparkles} from "lucide-react";
import {SiteHeader} from "@/components/SiteHeader";
import {WhatsAppButton, WhatsAppIcon} from "@/components/WhatsAppButton";
import {api, CATEGORY_LABEL, LOGO_ON_WHITE, WA_LINK} from "@/lib/inner";

const STEPS = [["01", "Pilih outlet & perawatan", "Pilih outlet favoritmu dan satu atau beberapa perawatan sekaligus."], ["02", "Atur waktu kunjungan", "Pilih tanggal dan jam yang masih tersedia, dalam WIB."], ["03", "Konfirmasi booking", "Isi nama panggilan dan WhatsApp. Selesai, tanpa login."]];

const OutletCard = ({b}) => (
  <article className="branch-card" data-testid={`outlet-card-${b.id}`}>
    <div className="branch-image"><img src={b.photo} alt={`INNER Salon Muslimah ${b.name}`}/><span>Outlet {b.name}</span></div>
    <div className="branch-body">
      <h3>{b.name}</h3>
      <p><MapPin size={13}/> {b.address}</p>
      <Link data-testid={`branch-${b.id}-booking-button`} to={`/booking?branch=${b.id}`} className="text-btn">Booking di outlet ini <ChevronRight size={16}/></Link>
    </div>
  </article>
);

export default function Home() {
  const [data, setData] = useState({branches: [], services: [], categories: []});
  useEffect(() => { api.get("/public/config").then(r => setData(r.data)); }, []);
  return <>
    <SiteHeader/>
    <main>
      <section className="hero">
        <div className="hero-copy">
          <p className="eyebrow"><Sparkles size={15}/> RUANG PRIVAT UNTUK MUSLIMAH</p>
          <h1>Beauty inside,<br/><em>beauty outside.</em></h1>
          <p className="lead">Ahlinya Rambut Hijab. Nyaman dan Privat. Pesan beberapa perawatan sekaligus di waktu terbaikmu, tanpa perlu registrasi.</p>
          <div className="hero-actions">
            <Link className="primary-btn" data-testid="hero-booking-button" to="/booking">Booking Perawatan <ChevronRight size={18}/></Link>
            <a className="wa-btn" data-testid="hero-whatsapp-button" href={WA_LINK} target="_blank" rel="noreferrer"><WhatsAppIcon size={18}/> Reservasi via WhatsApp</a>
          </div>
          <div className="trust-row"><span><ShieldCheck/> Terapis perempuan</span><span><Heart/> Privasi terjaga</span><span><Sparkles/> Produk halal</span></div>
        </div>
        <div className="hero-visual">
          <img src="https://www.innersalonmuslimah.com/interior/hair-and-face-treatment-innersalon-muslimah-002.jpeg" alt="Ruang perawatan privat INNER"/>
          <div className="floating-note"><span>10+</span><small>Tahun melayani<br/>muslimah Indonesia</small></div>
        </div>
      </section>
      <section className="band intro">
        <div><p className="eyebrow">PILIH PERAWATANMU</p><h2>Waktu untuk kembali<br/><em>menjadi dirimu.</em></h2></div>
        <div className="category-grid">
          {data.categories.map((x, i) => <Link data-testid={`category-${x.toLowerCase()}-card`} to={`/booking?category=${x}`} className="category" key={x}><span>0{i + 1}</span><b>{CATEGORY_LABEL[x]}</b><small>{data.services.filter(s => s.category === x).length} perawatan</small><ChevronRight/></Link>)}
        </div>
      </section>
      <section className="band branches" id="outlet">
        <div className="section-heading">
          <div><p className="eyebrow">HADIR DI DEPOK</p><h2>Temukan outlet<br/><em>terdekatmu.</em></h2></div>
          <span className="section-caption">Empat outlet, satu standar kenyamanan. Buka setiap hari.</span>
        </div>
        <div className="branch-grid">{data.branches.map(b => <OutletCard b={b} key={b.id}/>)}</div>
      </section>
      <section className="band steps" id="cara">
        <div className="section-heading"><div><p className="eyebrow">SESEDERHANA ITU</p><h2>Booking dalam<br/><em>tiga langkah.</em></h2></div></div>
        <div className="step-grid">{STEPS.map(([n, t, d]) => <div className="step" key={n}><span>{n}</span><h3>{t}</h3><p>{d}</p></div>)}</div>
      </section>
    </main>
    <footer><img className="footer-logo" src={LOGO_ON_WHITE} alt="INNER Salon Muslimah"/><small>Beauty Inside, Beauty Outside.</small><Link to="/staff" data-testid="footer-staff-link">Akses staf <LogIn size={14}/></Link></footer>
    <WhatsAppButton/>
  </>;
}
